import { Panel } from "primereact/panel"
import { TabPanel, TabView } from "primereact/tabview"
import { useEffect, useRef, useState, createContext } from "react";
import { ParametroEmpresa } from "./ParametroEmpresa";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Toast } from "primereact/toast";
import { TransaccionalCalendario } from "./TransaccionalCalendario";
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import multiMonthPlugin from '@fullcalendar/multimonth';
import { useToken } from '../../components/useToken';
import { ListaTransaccion } from "./ListaTransaccion";
import { ProgressSpinner } from "primereact/progressspinner";
import { Generico } from "../../components/Generico";

export const TransaccionalContext = createContext(null);

export const Transaccional = () => {
    const { getRol } = useToken();
    const [activeIndex, setActiveIndex] = useState(0);
    const [permss, setPermss] = useState(null);
    const [funcionalidades, setFuncionalidades] = useState([]);
    const [instrumentosPago, setInstrumentosPago] = useState([]);
    const [nivelesRiesgo, setNivelesRiesgo] = useState([]);
    const [nivelesAlerta, setNivelesAlerta] = useState([]);
    const [nivelesSupera, setNivelesSupera] = useState([]);
    const [justificaciones, setJustificaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const monitoreoService = new MonitoreoService();
    const toast = useRef(null);
    const generico = Generico();

    useEffect(() => {
        inicio();
    }, []);

    useEffect(() => {
        if (funcionalidades.length > 0) {
            const tabsOrdenadas = [ // Deben tener el mismo orden declarado en el acordeón
                { key: "monitoreo-transaccional-vista-lista" },
                { key: "monitoreo-transaccional-vista-mes" },
                { key: "monitoreo-transaccional-vista-year" },
                { key: "monitoreo-transaccional-configuracion" }
            ];

            const primerIndexVisible = tabsOrdenadas.findIndex(tab =>
                funcionalidades.includes(tab.key)
            );

            if (primerIndexVisible !== -1) {
                setActiveIndex(primerIndexVisible);
            }
        }
    }, [funcionalidades]);

    const inicio = () => {
        const rolId = getRol()?.id ?? '';
        monitoreoService.consultar(0, 'monitoreo/transaccional/permission', { rol: rolId }).then(res => {
            setPermss(res.data.perss);
            setFuncionalidades(res.data.funcionalidades);
            setJustificaciones(res.data.justificaciones);
            setInstrumentosPago(res.data.instrumentos_pago);
            setNivelesRiesgo(res.data.niveles_de_riesgo);
            setNivelesAlerta(res.data.niveles_de_alerta);
            setNivelesSupera(res.data.niveles_supera);
        }).finally(() => {
            setLoading(false)
        });
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    }

    const contextoData = { instrumentosPago, nivelesRiesgo, nivelesAlerta, nivelesSupera, justificaciones, };

    return (
        <>
            <Toast ref={toast} />
            <div style={{ position: 'relative', minHeight: '500px' }}>
                {loading && (
                    <div style={{ position: 'absolute', zIndex: 10, top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '1rem', fontSize: '1.2rem', color: '#444', fontWeight: 500 }} >
                        <ProgressSpinner style={{ width: '57.5px', height: '57.5px' }} strokeWidth="5" fill="var(--surface-ground)" animationDuration=".5s" />
                        <span>Un momento por favor, estamos cargando la información...</span>
                    </div>
                )}
                <div style={{ opacity: loading ? 0.3 : 1, pointerEvents: loading ? 'none' : 'auto', transition: 'opacity 0.3s ease' }}></div>
                {!loading && (
                    <TransaccionalContext.Provider value={contextoData}>
                        <Panel>
                            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                {siOpcion("monitoreo-transaccional-vista-lista") && (
                                    <TabPanel header="Vista en lista">
                                        <ListaTransaccion permss={permss} funcionalidades={funcionalidades} toast={toast} generic={generico} />
                                    </TabPanel>
                                )}
                                {siOpcion("monitoreo-transaccional-vista-mes") && (
                                    <TabPanel header="Vista mensual">
                                        <TransaccionalCalendario permss={permss} funcionalidades={funcionalidades} toast={toast} generic={generico} plugins={[interactionPlugin, dayGridPlugin]} initialView="dayGridMonth" tipoFechaTabla="TIP_RAN_FEC_MATRIZ_DIA" />
                                    </TabPanel>
                                )}
                                {siOpcion("monitoreo-transaccional-vista-year") && (
                                    <TabPanel header="Vista anual">
                                        <TransaccionalCalendario permss={permss} funcionalidades={funcionalidades} toast={toast} generic={generico} plugins={[interactionPlugin, multiMonthPlugin]} initialView="multiMonthYear" tipoFechaTabla="TIP_RAN_FEC_MATRIZ_DIA" />
                                    </TabPanel>
                                )}
                                {siOpcion("monitoreo-transaccional-configuracion") && (
                                    <TabPanel header="Configuraciones">
                                        <ParametroEmpresa toast={toast} generic={generico} permss={permss} funcionalidades={funcionalidades} />
                                    </TabPanel>
                                )}
                            </TabView>
                        </Panel>
                    </TransaccionalContext.Provider>
                )}
            </div>
        </>
    )
}
